var map = {
	"./background.jpg": 28,
	"./bg.png": 29,
	"./flags/be.svg": 30,
	"./flags/cn.svg": 31,
	"./flags/de.svg": 32,
	"./flags/es.svg": 33,
	"./flags/fr.svg": 34,
	"./flags/gb.svg": 35,
	"./flags/it.svg": 36,
	"./flags/jp.svg": 37,
	"./flags/us.svg": 38,
	"./icons/arrow.svg": 39,
	"./icons/back.svg": 40,
	"./icons/close.svg": 41,
	"./icons/deco.svg": 42,
	"./icons/download.svg": 43,
	"./icons/error.svg": 44,
	"./icons/facebook.svg": 45,
	"./icons/glass.svg": 46,
	"./icons/info.svg": 47,
	"./icons/instagram.svg": 48,
	"./icons/linkedin.svg": 49,
	"./icons/marker.svg": 50,
	"./icons/pinterest.svg": 51,
	"./icons/play.svg": 52,
	"./icons/point.svg": 53,
	"./icons/shop.svg": 54,
	"./icons/slider-arrow.svg": 55,
	"./icons/star.svg": 56,
	"./icons/success.svg": 57,
	"./icons/twitter.svg": 58,
	"./icons/weibo.svg": 59,
	"./icons/youtube.svg": 60,
	"./logo-footer.png": 61,
	"./logo-secondary.svg": 62,
	"./logo-top.svg": 63,
	"./logo.png": 64,
	"./marker.svg": 65,
	"./pattern-secondary.png": 66,
	"./pattern.png": 67,
	"./quote.svg": 68,
	"./texture-menu.jpg": 69,
	"./textures.jpg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;